import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 lg:px-16 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20silk%20fabric%20in%20warm%20terracotta%20and%20soft%20cream%20tones%2C%20elegant%20textile%20art%20photography%2C%20smooth%20organic%20curves%20and%20folds%2C%20luxurious%20material%20texture%2C%20soft%20diffused%20lighting%2C%20artistic%20fashion%20editorial%20background%2C%20sophisticated%20warm%20color%20gradients%2C%20ethereal%20dreamy%20atmosphere%2C%20high%20end%20boutique%20visual%20merchandising%20style&width=1920&height=600&seq=cta-v3-bg-final&orientation=landscape"
          alt="Vigorbuy Spreadsheet - Start your journey"
          title="Vigorbuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/80 via-foreground-900/50 to-foreground-900/30"></div>
      </div>

      {/* Content - Triangle Layout */}
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 min-h-[320px]">

          {/* Top Left: Title */}
          <div className="md:w-1/2">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-white leading-tight">
              Start Your
              <br />
              Spreadsheet
              <br />
              <span className="italic font-light">Journey</span>
            </h2>
          </div>

          {/* Bottom Right: Description */}
          <div className="md:w-1/3 md:text-right md:self-end">
            <p className="text-white/75 text-base md:text-lg leading-relaxed">
              Explore the latest <strong className="text-white font-semibold">updated vigorbuy spreadsheet</strong> today and discover organized products, helpful guides, and weekly updates.
            </p>

            {/* Button */}
            <div className="mt-6 md:flex md:justify-end">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Visit Kaspreadsheet
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-white group-hover:translate-x-1 transition-transform duration-200">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}